import { styled } from 'parkdepot-shared/theme'

const CardWrapper = styled('div', () => ({
    position: 'absolute',
    bottom: '16px',
    left: 0,
    right: 0,
    margin: '0 16px'
}))

export default CardWrapper
